import React from 'react';
import loadable from '@loadable/component';

const SidebarFilterLoadable = loadable(
  () => import(/* webpackChunkName: "sidebar-views-filter" */ './view')
);

const SidebarFilter = () => <SidebarFilterLoadable />;

export default SidebarFilter;
